export const fetchSectionTree = () => Promise.resolve({
    ancestors: [],
    descendants: [],
    description: 'Whole site',
    name: 'root',
    parent_section_id: false,
    parent_section_name: null,
    processing_status: 1,
    section_id: 4774600013682,
    vector_clock: 0,
});
